/** LockedIn — single subscription product: LockedIn Plus. */

export const SUBSCRIPTION_TRIAL_DAYS = 7;

export const SUBSCRIPTION_TIER_IDS = {
  PLUS: 'lockedin_plus',
};

export const LOCKEDIN_PLUS_TIER_ID = SUBSCRIPTION_TIER_IDS.PLUS;

export const SUBSCRIPTION_TIERS = [
  {
    id: SUBSCRIPTION_TIER_IDS.PLUS,
    name: 'LockedIn Plus',
    tagline: 'Premium features',
    description:
      'Unlock premium features and keep more of your challenge earnings.',
    price: 7.99,
    priceLabel: '$7.99',
    accent: 'emerald',
    features: [
      '2% platform service fee on challenge earnings',
      'Custom challenges',
      'Private chat',
      'Premium features',
      'Unlimited friends',
      'Score streaks & opponent stats',
    ],
  },
];

export function getTierById(tierId) {
  return tierId === SUBSCRIPTION_TIER_IDS.PLUS ? SUBSCRIPTION_TIERS[0] : null;
}

export function getTierDisplayName(tierId) {
  if (tierId === SUBSCRIPTION_TIER_IDS.PLUS) return SUBSCRIPTION_TIERS[0].name;
  return 'Free';
}
